import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { UserTrainingStatistics } from 'models/UserTrainingStatistics';
import { getStatistics } from 'api/services/lesson-service';
import { useState, useEffect, useCallback } from 'react';
import { formatDateToCustomString, formatTimeSpanToCustomString } from 'helpers/dateHelper';

export const useStatistics = () => {
    const [statistics, setStatistics] = useState<UserTrainingStatistics[]>([]);
    const { callAPI, loading } = useWorkspaceApiCall(getStatistics, '', 'getStatistics.error');

    const fetchStatistics = useCallback(async () => {
        const resp = await callAPI('');
        if (resp?.success && resp.data) {
            setStatistics(resp.data.map((stat) => {
                return {
                    ...stat,
                    dateCompleted: stat.dateCompleted ? formatDateToCustomString(stat.dateCompleted, true) : null,
                    timeSpent: stat.timeSpent ? formatTimeSpanToCustomString(stat.timeSpent, true) : null,
                }
            }));
        }
    }, [callAPI]);

    useEffect(() => {
        fetchStatistics();
    }, [fetchStatistics]);

    return { statistics, gettingStatistics: loading };
}